import { Base } from './../base';
import { Region } from 'src/models/geography/region';

export class City extends Base {
    region?: Region = new Region();
}